import gql from 'graphql-tag';

export default gql`
  fragment ClientUrlParams on ClientUrlParams {
    id
    params_status
    content_domain
    configuration {
      key
      value
      dynamic_value
      value_options
      default_option_value
    }
  }
`;
